export default "__VITE_ASSET__Cd7sb_jh__"